/** QC Standards: every active crop's pass marks (user, 2026-09-30). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { QcStandardsPage } from "@/features/quality/components/standards/qc-standards-page";

export const Route = createFileRoute("/_app/quality/standards/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.standards")) throw redirect({ to: "/" });
  },
  component: QcStandardsPage,
});
